// extracted by mini-css-extract-plugin
export default {"app":"App_app__b-G45","main":"App_main__GMT7B"};